import { useEffect } from 'react'
import { Select, Typography } from 'antd'
import { Tag } from 'lucide-react'
import { useUIStore } from '@/store/uiStore'
import { useProjectTags } from '@/api/projects.api'
import { t } from '@/config/translations'
import styles from './TagSelector.module.css'

const { Text } = Typography

export function TagSelector() {
  const { selectedProjectId, activeTags, setActiveTags } = useUIStore()
  const { data: tagsData } = useProjectTags(selectedProjectId)

  // Reset to defaults when project changes or tags data loads
  useEffect(() => {
    if (tagsData) {
      setActiveTags(tagsData.default_tags)
    }
  }, [selectedProjectId, tagsData, setActiveTags])

  // Don't render if project has no tags
  if (!tagsData || tagsData.tags.length === 0) {
    return null
  }

  return (
    <div className={styles['tagSelector']}>
      <div className={styles['label']}>
        <Tag size={14} />
        <Text type="secondary">{t('source_tags') || 'Sources'}</Text>
      </div>
      <Select
        mode="multiple"
        size="small"
        placeholder={t('all_sources') || 'All sources'}
        value={activeTags}
        onChange={setActiveTags}
        options={tagsData.tags.map((tag) => ({ label: tag, value: tag }))}
        maxTagCount="responsive"
        className={styles['select']}
        allowClear
      />
    </div>
  )
}
